import { useNavigate, NavigateFunction } from "react-router-dom";
import { CLOSE_WARNING } from "../../consts";
import { Button, ButtonProps } from "../mui";

export const CloseButton = (
  props: ButtonProps & {
    confirm?: boolean;
    onClick?: () => void;
  }
) => {
  const navigate = useNavigate();

  const handleClose = (confirm?: boolean) => {
    if (confirm) {
      if (window.confirm(CLOSE_WARNING) === true) {
        if (props.onClick) props.onClick();
        else navigate(`../`);
      }
    } else {
      if (props.onClick) props.onClick();
      else navigate(`../`);
    }
  };

  const { confirm, onClick, ...rest } = props;

  return (
    <Button onClick={() => handleClose(confirm)} variant="outlined" {...rest}>
      Close
    </Button>
  );
};

export const handleClose = (nav: NavigateFunction, confirm?: boolean) => {
  if (confirm) {
    if (window.confirm(CLOSE_WARNING) === true) {
      nav(`../`);
    }
  } else {
    nav(`../`);
  }
};
